import { OverrideStatusEnum } from 'src/common/external/bambi-api/bambiApi';

import { ACTIVE_TRIP_STATUSES } from './ACTIVE_TRIP_STATUSES';

export function isActiveTrip(tripStatus: OverrideStatusEnum) {
  return ACTIVE_TRIP_STATUSES.includes(tripStatus);
}
